import ConsultarIpva from "../dar-ipva/ConsultarIPVA";
import DebitosIpva from "../debitos/DebitosIpva";
import AnistiaIpva from "../anistia/Anistia";
import VeiculosPorProprietario from "../veiculos-por-proprietario/VeiculosPorProprietario";
export var Routes = {
    "/dar-ipva/anistia": AnistiaIpva,
    "/dar-ipva/debitos": DebitosIpva,
    "/counsulta-ipva": ConsultarIpva,
    "/": VeiculosPorProprietario,
};
